/*
 * @Author: vinc
 * @LastEditTime: 2020-11-18 17:30:58
 */
let data = {
    dev: {
        shop_web: 'http://192.168.0.167:8080',//官网
        shop_pc: "http://192.168.0.167:3008", //商城
        shop_business: "http://192.168.0.167:3007", //企业商城
        shop_business_admin: "http://192.168.0.167:3009", //企业端
        shop_wap: "http://192.168.0.167:3008", //移动端预留
        supplier_admin: "http://192.168.0.146:8081", //供应商
        business_admin: "http://192.168.0.146:8080" //商家端
    },
    test: {
        shop_web: 'https://flweb.qx.com',//官网
        shop_pc: "http://mall.internal.17cai.com", //商城
        shop_business: "http://corp-emp.internal.17cai.com", //企业商城
        shop_business_admin: "http://corp.internal.17cai.com", //企业端
        shop_wap: "http://mall.internal.17cai.com", //移动端预留
        supplier_admin: "http://supply.internal.17cai.com", //供应商
        business_admin: "http://shop.internal.17cai.com" //商家端
    },
    master: {
        shop_web: 'https://flweb.qx.com',//官网
        shop_pc: "http://mall.internal.17cai.com", //商城
        shop_business: "http://corp-emp.internal.17cai.com", //企业商城
        shop_business_admin: "http://corp.internal.17cai.com", //企业端
        shop_wap: "http://mall.internal.17cai.com", //移动端预留
        supplier_admin: "http://supply.internal.17cai.com", //供应商
        business_admin: "http://shop.internal.17cai.com" //商家端
    },
    release: {
        shop_web: 'https://flweb.qx.com',//官网
        shop_pc: "https://fuli.qx.com", //商城
        shop_business: "https://flemp.qx.com", //企业商城
        shop_business_admin: "https://flcorp.qx.com", //企业端
        shop_wap: "https://fl.qx.com", //移动端预留
        supplier_admin: "https://flsupply.qx.com", //供应商
        business_admin: "https://flshop.qx.com", //商家端
    }
}

module.exports = data


// WEBPACK FOOTER //
// ./src/assets/js/path.js